import React from 'react';

const SectionHeader = ({ id, title, slug, first = false }) => (
  <header id={id} className={`sm-section-head ${first ? 'sm-section-head--first' : ''}`}>
    <div>
      {slug ? <div className="sm-section-head__slug">{slug}</div> : null}
      <h2 className="sm-section-head__title">{title}</h2>
    </div>
  </header>
);

export default SectionHeader;
